/* eslint-disable no-console */
import Rollbar from 'rollbar';
import getCloudEnv from '~util/cloudEnv';

const env = getCloudEnv();

const rollbarConfig = {
  //  TODO: convert this token to a more general Gogo DASH account token.
  accessToken: '51efec3d271c482c989f884b047fc636',
  captureUncaught: true,
  captureUnhadledRejections: true,
  payload: {
    environment: env,
  },
};

//  Outer object we attach custom handlers to below.
const logger = {};

//  Turn on rollbar for prod only.
if (env === 'production' || env === 'stage') {
  const rollbar = new Rollbar(rollbarConfig);

  //  In production we want the majority of console calls to be
  //  silenced (console.log/info/debug/trace/group/etc.).
  Object.keys(console).forEach(key => {
    const slot = console[key];
    if (typeof slot === 'function') {
      //  NOTE these are essentially no-op functions to silence
      //  normal development log messages etc.
      logger[key] = () => {};
    }
  });

  logger.error = (...args) => {
    console.error(...args);
    //  Errors should log and invoke Rollbar api.
    rollbar.error(...args);
  };
} else {
  //  In non-production environments we want logger.* to map to
  //  console.* without any extra overhead or filtering.
  Object.keys(console).forEach(key => {
    const slot = console[key];
    if (typeof slot === 'function') {
      //  NOTE these are effectively simple forwarding wrappers
      //  so invoking logger.* just calls console.*.
      logger[key] = (...args) => {
        console[key](...args);
      };
    }
  });
}

// TODO: User attribution logging, might be fun later
// export const setUser = ({ id, username, email }) => {
//   console.log(`setting user: ${id} - ${username} - ${email}`);
//   rollbar.configure({
//     payload: {
//       person: {
//         id,
//         username,
//         email,
//       },
//     },
//   });
//   console.log(rollbar.configuration);
// };

// export const resetUser = () => {
//   console.log('resetting user');
//   rollbar.configure({
//     payload: {
//       person: null,
//     },
//   });
//   console.log(rollbar.configuration);
// };

export default logger;
